





























import {OmniUsuarioEnum} from '@/helpers/omni-usuario.enum';
import {Component, Vue} from 'vue-property-decorator';

@Component({
  name: 'navbar',
})
export default class Navbar extends Vue {

  public clientId: string | null = localStorage.getItem(OmniUsuarioEnum.OMNI_KEYCLOAK_CLIENTID) ? localStorage.getItem(OmniUsuarioEnum.OMNI_KEYCLOAK_CLIENTID) : '';
}
